export default {
  tagline: "O jogo popular de cartas, online. 🕵️‍♂️",
  "create-game": "Criar um jogo",
  "new-game": "Novo jogo",
  "back-to-lobby": "De volta ao lobby",
  "join-room": "Entrar em um jogo",
  "no-public-room":
    "Nenhum jogo público disponível no momento. Crie um e convide seus amigos!!",
  "how-to-play": "Como jogar",
  "game-tagline":
    "Codegame é um jogo de adivinhação, onde times competem para encontrar palavras a partir de dicas dadas pelos jogadores.",
  "see-more": "Ver mais...",
  "classic-rules": "Regras - Clássico",
  "duet-rules": "Regras - Dueto",
  "support-authors":
    "Se você gosta do jogo, por favor, colabore com os autores e compre uma cópia física!",
  "made-with-love": "Feito com ♥ durante o lockdown",
  "its-open-source": "É <1>open-source</1>.",
  "check-our-privacy-policy": "Confira nossa <2>política de privacidade</2>.",
  "choose-options": "Escolha suas opções",
  mode: "Modo",
  duet: "Dueto",
  classic: "Clássico",
  dictionary: "Dicionário",
  "public-game": "Jogo público",
  private: "Privado",
  public: "Público",
  "join-game": "Entrar em um jogo",
  "placeholder-join": "entre em um jogo para iniciar um chat",
  "give-hint": "dar uma dica",
  "clicked-on": "Clicou em",
  "become-spymaster": "Tornar-se Mestre-Espião",
  "switch-teams": "Trocar de time",
  "red-adj": "vermelho",
  "blue-adj": "azul",
  "start-game-classic":
    "O Mestre-Espião <1>{{team}}</1> dá uma dica para começar o jogo!",
  "see-rules": "Ver regras",
  "start-game-duet": "Clique em uma carta ou dê uma dica para iniciar o jogo!",
  "copied-to-clipboard": "Copiado para a área de transferência!",
  "turns-left": "{{ count }} turno restante",
  "turns-left_plural": "{{ count }} turnos restantes",
  "game-over": "Fim de jogo.",
  "winner-team": "O time <1>{{team}}</1> venceu!",
  "black-card-loss": "Você perdeu porque clicou em uma carta preta.",
  "out-of-time-loss": "Acabou o tempo!",
  won: "Você venceu!",
  "join-red": "juntar-se ao vermelho",
  "join-blue": "juntar-se ao azul",
  "join-side": "juntar-se ao lado",
  spectate: "observar",
  "game-started": "começou",
  "page-title": "Codegame - Jogue Online",
  "page-description":
    "Jogue Codegame online, um jogo de palavras multijogador, disponível para celular e desktop. Neste jogo de adivinhação, times competem para encontrar palavras a partir de dicas dadas pelos jogadores.",
  "in-the-room": "Na sala",
  rules: "Regras",
  // todo rules...
  red: "Vermelho",
  blue: "Azul",
  duetA: "Lado A",
  duetB: "Lado B",
  spectator: "Observando",
  "just-joined": "entrou no jogo!",
  "game-created": "O jogo foi criado.",
  "no-players-yet": "Ainda não há jogadores nesse time!",
  "player-name-placeholder": "Nome do jogador",
  cards: "cartas",
  buymeacoffee: "Apóie o jogo, compre-me um café",
  "positive-reaction-1": "Legal!",
  "positive-reaction-2": "Bom trabalho!",
  "positive-reaction-3": "Ótima escolha.",
  "positive-reaction-4": "Um ponto!",
  "positive-reaction-5": "Boa!",
  "positive-reaction-6": "😎",
  "neutral-reaction-1": "É, está errado.",
  "neutral-reaction-2": "Passou perto.",
  "neutral-reaction-3": "Quem sabe da próxima vez.",
  "neutral-reaction-4": "Era só um civil.",
  "neutral-reaction-5": "Quase!",
  "neutral-reaction-6": "Que pena.",
  "black-reaction-1": "Você acaba de perder o jogo!",
  "black-reaction-2": "O time adversário venceu!",
  "black-reaction-3": "O seu time perdeu ☠️",
  "black-reaction-4": "Ah, não, você clicou em um assassino ☠️",
  "negative-reaction-1": "Ooooops!",
  "negative-reaction-2": "Ah, não!",
  "negative-reaction-3": "O time adversário agradece.",
  "negative-reaction-4": "Você fez o seu melhor 💛.",
  "negative-reaction-5": "🤦‍♂️",
  "rules-classic-teams": `Os jogadores são divididos em dois times: <1>vermelho</1> e <3>azul</3>. Cada time escolhe um dos jogadores para ser o Mestre-Espião 🕵️‍♂️ - os outros são operadores de campo.`,
  "rules-classic-grid": `Vinte e cinco cartas com palavras são aleatoriamente distribuídas em linhas e colunas. Algumas dessas palavras representam agentes <1>vermelhos</1>, algumas representam agentes <3>azuis</3>, uma representa um <5>assassino</5>, e as outras representam <7>pessoas inocentes</span>. Os Mestres-Espiões dos times sabem as cores de cada palavra, e se alternam dando dicas para seus times, para que eles encontrem as palavras com suas cores.`,
  "rules-classic-hints": `Cada dica deve ter somente uma única palavra e o número de cartas com as quais ela está relacionada. O Mestre-Espião pode dar dicas relacionadas com tantas palavras quanto possível, a respeito de seus próprios agentes, mas não relacionadas com nenhuma outra – elas podem acidentalmente levar o time a escolher uma carta que represente uma pessoa inocente, um agente adversário, ou o assassino.`,
  "rules-hint-restrictions": `A palavra da dica pode ser escolhida livremente, desde que não esteja presente na mesa ou contida em alguma palavra da mesa que esteja visível no momento. Dicas fonéticas normalmente são proibidas.`,
  "rules-turns":
    "As cartas são reveladas conforme as escolhas são feitas. Operadores de campo precisam fazer ao menos uma escolha por turno, mesmo que corra o risco de um palpite errado e suas consequências. Após o primeiro palpite, eles podem encerrar o turno voluntariamente, se quiserem. Eles podem arriscar tantos palpites quanto sugerido pelo Mestre-Espião, mais um (um bônus, para tentar acertar baseando-se em uma dica dada anteriormente).",
  "rules-classic-game-end": `O jogo termina quando um time identifica todos os agentes (🏅), ou quando algum dos times encontra o  <1>assassino</1> (☠️).`,
  "rules-duet-objective": `Dois jogadores cooperam para encontrar 15 palavras na mesa.`,
  "rules-duet-grid": `Vinte e cinco cartas com palavras são aleatoriamente distribuídas em linhas e colunas. Algumas dessas palavras representam agentes <1>verdes</1>, algumas representam <3>assassinos</3>, e as outras representam <5>pessoas inocentes</5>. Cada jogador conhece 9 palavras <7>verdes</7>, algumas delas comuns a ambos os lados.`,
  "rules-duet-hints": `Os jogadores se alternam dando dicas para que o outro jogador encontre suas cartas verdes. Cada dica deve ter somente uma única palavra e o número de cartas com as quais ela está relacionada. Os jogadores podem dar dicas relacionadas com tantas palavras quanto possível a respeito de seus próprios agentes, mas não relacionadas com nenhuma outra – elas podem acidentalmente levar o outro jogador a escolher uma carta que represente uma pessoa inocente ou um assassino.`,
  "rules-duet-game-end": `O jogo termina quando todos os 15 agentes verdes são identificados (🏅), ou quando algum dos jogadores encontra um <1>assassino</1> (☠️). O jogo tem tempo, o que significa que os jogadores têm um total de 9 turnos para encontrar todas as palavras. Clicar em uma <3>pessoa inocente</span> consome um turno extra.`,
  "long-story-short": "Resumindo",
  "privacy-tldr": `
  <p>Mantemos os jogos e chats em nossos bancos de dados por um período de tempo, mas eles podem ser apagados a qualquer momento. Essas são as únicas informações que armazenamos.</p>
  <p>Usamos cookies para que possamos ver estatísticas (analytics) sobre o uso do site (demografia, duração de sessões, tipos de jogos jogados). Essas estatísticas não contém informações que permitam identificar uma pessoa.</p>
  <p>Nosso provedor de estatísticas é o Google Analytics.</p>
`,
};
